export var globals = {
    window: typeof window === 'undefined' ? null : window,
    document: typeof document === 'undefined' ? null : document
};
export function registerWindow() {
    var win = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, doc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    globals.window = win;
    globals.document = doc;
}
var save = {};
export function saveWindow() {
    save.window = globals.window;
    save.document = globals.document;
}
export function restoreWindow() {
    globals.window = save.window;
    globals.document = save.document;
}
export function withWindow(win, fn) {
    saveWindow();
    registerWindow(win, win.document);
    fn(win, win.document);
    restoreWindow();
}
export function getWindow() {
    return globals.window;
}
